import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { StorageService } from './storage.service';
import { Properties } from '../app/app-config/properties';
import { catchError, map, timeout } from 'rxjs/operators';
import { ChangePasswordInterface } from '../shared/model/app';
import { CustomizationService } from './customization.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<any>;

  constructor(private _localStorage: StorageService, private http: HttpClient,private customizationService:CustomizationService) {
    this.currentUserSubject = new BehaviorSubject<any>(
      _localStorage.getUserUserCredential()
    );
  }

  get currentUser(): Observable<any> {
    return this.currentUserSubject.asObservable();
  }

  logout() {
    // remove user from local storage to log user out
    this._localStorage.logOut();
    this._localStorage.removeUserTimeOut();
    this.currentUserSubject.next(null);
  }

  changePassword(
    data: ChangePasswordInterface,
    email: string
  ): Observable<any> {
    return this.http
      .post(Properties.CHANGE_PASSWORD_NO_TOKEN_ENDPOINT, {...data, email})
      .pipe(
        timeout(50000),
        map((response: Response) => response),
        catchError((e) => {
          return throwError(e);
        })
      );
  }

  encodeCredential(payload:any, secretKey: string): Observable<any> {
    return this.http
    .post(Properties.ENCODE_CREDENTIAL_ENDPOINT, {payload, secretKey})
    .pipe(
      timeout(50000),
      map((response: Response) => response),
      catchError((e) => {
        return throwError(e);
      })
    );
  }
}
